import React from 'react';

import { Header, Footer, ScrollTop, ScrollToTop, ProfileSingle } from './components';
import { HomePage, AboutUs, TestimonialsPage, BlogGrid, BlogList, BlogSingle, Login, Register, ForgotPwd, ShopGrid, ShopList, Cart, Checkout, Contact, ProductSingle, Wishlist, ServiceSingle, TeamPage, ServicePage, GamePage, Gallery, OrderConfirmation, FaqPage, Speakers, ScheduleSingle, PortfolioPage, PortfolioSingle, TicketPage, SponsorsPage, Venue, RegistrationPage, ScheduleTabPage, ScheduleListPage, ScheduleEventPage, GameSingle } from './sections';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';



const App = () => {

  return (

    <div className='App'>

      {/* Component to Scroll to Top on Route Change */}
      <ScrollToTop />

      {/* Render the header component */}
      <Header />

      <Routes>

        {/*Home*/}
        <Route path='/' element={<HomePage />} />

        {/*About*/}
        <Route path='/About-us' element={<AboutUs />} />
        <Route path='/Team' element={<TeamPage />} />  
        <Route path='/Team/:id' element={<ProfileSingle type="team" />} />    
        <Route path='/Team/Team-Single' element={<ProfileSingle type="team" />} /> 
        <Route path='/Testimonials' element={<TestimonialsPage />} /> 
        <Route path='/Faqs' element={<FaqPage />} />

        {/*Speakers*/}
        {/* <Route path='/Speakers' element={<Speakers />} />  
        <Route path='/Speakers/:id' element={<ProfileSingle type="speaker" />} />
        <Route path='/Speakers/Speaker-Single' element={<ProfileSingle type="speaker" />} /> */}

        {/*Schedule*/}
        <Route path='/ScheduleTab' element={<ScheduleTabPage />} />     
        <Route path='/ScheduleList' element={<ScheduleListPage />} />     
        <Route path='/ScheduleEvent' element={<ScheduleEventPage />} />     
        <Route path='/Schedule/:id' element={<ScheduleSingle />} />    
        <Route path='/Schedule/Schedule-Single' element={<ScheduleSingle />} /> 

        {/*Pages*/}
        <Route path='/Gallery' element={<Gallery />} />   

        <Route path='/Portfolio' element={<PortfolioPage />} />   
        <Route path='/Portfolio/:id' element={<PortfolioSingle />} />   
        <Route path='/Portfolio/Portfolio-Single' element={<PortfolioSingle />} /> 

        <Route path='/Services' element={<ServicePage />} />   
        <Route path='/Services/:id' element={<ServiceSingle />} />   
        <Route path='/Services/Service-Single' element={<ServiceSingle />} /> 

        <Route path='/Games' element={<GamePage />} />   
        <Route path='/Games/:id' element={<GameSingle />} />   
        <Route path='/Games/Game-Single' element={<GameSingle />} /> 


        <Route path='/Tickets' element={<TicketPage />} />    
        {/* <Route path='/Registration' element={<RegistrationPage />} />     */}
        <Route path='/Sponsors' element={<SponsorsPage />} />    
        <Route path='/Venue' element={<Venue />} />    

        {/*Blogs*/}
        {/* <Route path='/Blog-grid' element={<BlogGrid />} /> 
        <Route path='/Blogs/category/:category' element={<BlogList />} /> 
        <Route path='/Blogs/tag/:tag' element={<BlogList />} /> 
        <Route path='/Blogs/search/:search' element={<BlogList />} /> 
        <Route path='/Blog-list' element={<BlogList />} /> 
        <Route path='/Blogs/:id' element={<BlogSingle  />} />
        <Route path='/Blogs/Blog-Single' element={<BlogSingle />} /> */}

        {/*Shop*/}
        {/* <Route path='/Shop-grid' element={<ShopGrid />} />  
        <Route path='/Shop/category/:category' element={<ShopList />} /> 
        <Route path='/Shop/tag/:tag' element={<ShopList />} /> 
        <Route path='/Shop/search/:search' element={<ShopList />} /> 
        <Route path='/Shop-list' element={<ShopList />} />
        <Route path='/Shop/:id' element={<ProductSingle />} />
        <Route path='/Shop/Product-Single' element={<ProductSingle />} /> 
        <Route path='/Wishlist' element={<Wishlist />} />
        <Route path='/Cart' element={<Cart />} />
        <Route path='/Checkout' element={<Checkout />} />
        <Route path='/OrderConfirmation' element={<OrderConfirmation />} />
        <Route path='/Login' element={<Login />} />  
        <Route path='/Register' element={<Register />} /> 
        <Route path='/Forgot-pwd' element={<ForgotPwd />} />  */}

        {/*Contact*/}
        <Route path='/contact-us' element={<Contact />} /> 

      </Routes>

      {/* Render the footer component */}
      <Footer />

      {/* Scroll to top button */}
      <ScrollTop />
      <ToastContainer />
      
    </div>

  )
}

export default App;
